import "./extra-select.scss"
import bottomIcon from "../../../assets/images/arrow-to-bottom-blue.svg"
import React, {useEffect, useMemo, useRef, useState} from "react";
import {useOnClickOutside} from "../../../hooks/useOnClickOutside";
import {Input} from "../index";

type Props = {
    options: { value: string, label: string }[];
    value: string | null;
    emptyMessage?: string;
    className?: string;
    onClick: (key: any) => void;
    name?: string
    tooltip?: { label: string; value: string };
    hideSearch?: boolean;
    label?: string
}

export const ExtraSelect: React.FC<Props> = ({ options, value, emptyMessage = "Not selected", className, onClick, name, tooltip, hideSearch, label }) => {
    const [isOpen, setIsOpen] = useState(false)
    const dropdownRef = useRef<HTMLDivElement>(null)
    useOnClickOutside({ ref: dropdownRef, handler: () => setIsOpen(false) })
    const [searchText, setSearchText] = useState("")

    const currentItem = options.find(el => String(el.value) === String(value))
    const currentData = currentItem?.label || emptyMessage

    useEffect(() => {
        if (!isOpen) setSearchText("")
    }, [isOpen]);

    const filteredOptions = useMemo(() => {
        const query = searchText.toLowerCase();
        return options.filter(opt => opt.label.toLowerCase().includes(query));
    }, [options, searchText]);

    return (
        <div>
            <div className={`${className} extra-select`} ref={dropdownRef}>
                {label && <label className={'input__label'}>{label}</label>}
                <div className="extra-select__current" onClick={() => setIsOpen(prev => !prev)}>
                    <span>{currentData}</span>
                    <div className="extra-select__current-right">
                        {tooltip && <p>
                            {tooltip.label}: <b>{tooltip.value}</b>
                        </p>}
                        <img src={bottomIcon} alt=""/>
                    </div>
                </div>
                {isOpen && <div className="extra-select__dropdown">
                    {!hideSearch && <Input
                        otherProps={{
                            style: {margin: "5px"},
                            placeholder: "Search by name",
                            value: searchText,
                            onChange: e => setSearchText(e.target.value),
                        }}
                    />}
                    <div style={{ maxHeight: "180px", overflow: "auto" }}>
                        {
                            filteredOptions.map((el, index) => (
                                <button
                                    name={name}
                                    value={el.value}
                                    onClick={(event) => {
                                        onClick(event)
                                        setIsOpen(false)
                                    }}
                                    key={el.value} className="extra-select__item">
                                    {el.label}
                                </button>
                            ))
                        }
                    </div>

                </div>}
            </div>
        </div>
    )
}